import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { AppModal, bodyTextSx } from "global/components/AppModal";

export default function InfoHelper({
  title,
  description,
  iconSize = "small",
  tooltipPlacement = "right",
  modal = false,
  iconColor = "action",
  /** Replaces the default `InfoOutlinedIcon` — for screens that trace their own glyph. */
  icon,
  /** Merged over the trigger's styles, e.g. to drop the default 44px hit area. */
  buttonSx,
}: any) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => modal && setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip
        title={
          <Box sx={{ maxWidth: 300 }}>
            <strong>{title}</strong>
            <br />
            {description}
          </Box>
        }
        placement={tooltipPlacement}
        arrow
      >
        <IconButton
          onClick={handleOpen}
          aria-label={`${title}: ${description}`}
          sx={{
            padding: 1,
            minWidth: "44px",
            minHeight: "44px",
            color: iconColor === "primary" ? "primary.main" : "text.secondary",
            ...buttonSx,
          }}
        >
          {icon ?? <InfoOutlinedIcon fontSize={iconSize} aria-hidden="true" />}
        </IconButton>
      </Tooltip>

      {modal && (
        <AppModal
          open={open}
          onClose={handleClose}
          title={title}
          tone="neutral"
          size="md"
        >
          <Typography sx={bodyTextSx}>{description}</Typography>
        </AppModal>
      )}
    </>
  );
}
